module.exports = __webpack_public_path__ + "img/4.4cf41763.png";